const ButtonContinueIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.75 8C0.75 7.58579 1.08579 7.25 1.5 7.25L16.5 7.25C16.9142 7.25 17.25 7.58579 17.25 8C17.25 8.41421 16.9142 8.75 16.5 8.75L1.5 8.75C1.08579 8.75 0.75 8.41421 0.75 8Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.96967 15.5303C8.67678 15.2374 8.67678 14.7626 8.96967 14.4697L15.4393 8L8.96967 1.53033C8.67678 1.23744 8.67678 0.762563 8.96967 0.469669C9.26256 0.176776 9.73744 0.176776 10.0303 0.469669L17.0303 7.46967C17.3232 7.76256 17.3232 8.23744 17.0303 8.53033L10.0303 15.5303C9.73744 15.8232 9.26256 15.8232 8.96967 15.5303Z"
      fill="currentColor"
    />
  </svg>
);

export default ButtonContinueIcon;
